import './domain-dashboard.component.ajscss';

import { timeParts } from '@commons/util/helper/time';
import { IHypervisionService } from '@hypervision/hypervision.service';
import { Domain } from '@hypervision/models/domain';
import { computeAvgProcessTime, computeHandledRate, computeOccupationRate } from '@hypervision/models/indicatrors.helper';
import { IChangesObject, IComponentController, IComponentOptions, isDefined, isObject, isString } from 'angular';

import { DisplayDeprecatedComponent } from '@contact/upgrade';

import templateUrl from './domain-dashboard.component.ajs.html';

class DomainDashboardViewCtrl extends DisplayDeprecatedComponent implements IComponentController {
  public selectedDomainId: string;
  public showAggregated: boolean;

  public selectedDomain: Domain | null;

  public occupationMetrics: any = {
    OCCUPATION_CSR_AVAILABLE: 0,
    OCCUPATION_CSR_BUSY: 0,
    OCCUPATION_CSR_PAUSE: 0,
    OCCUPATION_CSR_TASK: 0,
  };

  public contactMetrics: any = {
    CONTACT_STATUS_OFFERED: 0,
    CONTACT_STATUS_HANDLED: 0,
    CONTACT_STATUS_ABANDONED: 0,
    CONTACT_STATUS_DISSUADED: 0,
  };

  public occupationMetricsMapping = {
    SUM_CSR_AVAILABLE_DOMAIN_NOW: 'OCCUPATION_CSR_AVAILABLE',
    SUM_CSR_TASK_DOMAIN_NOW: 'OCCUPATION_CSR_TASK',
    SUM_CSR_WORKING_DOMAIN_NOW: 'OCCUPATION_CSR_BUSY',
    SUM_CSR_NOT_WORKING_DOMAIN_NOW: 'OCCUPATION_CSR_PAUSE',
  };

  public contactMetricsMapping = {
    SUM_CTT_SUCCESS_DOMAIN: 'CONTACT_STATUS_HANDLED',
    SUM_CTT_CREATED_DOMAIN: 'CONTACT_STATUS_OFFERED',
    SUM_CTT_DISSUADED_DOMAIN: 'CONTACT_STATUS_DISSUADED',
    SUM_CTT_GAVE_UP_DOMAIN: 'CONTACT_STATUS_ABANDONED',
  };

  constructor(private readonly hypervision: IHypervisionService) {
    super();
  }

  $onInit() {
    this.hypervision.onUpdated(() => this.getDomainData(this.selectedDomainId));
    this.getDomainData(this.selectedDomainId);
  }

  $onChanges(onChangesObj: { [property: string]: IChangesObject }) {
    if (onChangesObj['selectedDomainId'] && isDefined(onChangesObj['selectedDomainId'].currentValue)) {
      this.selectedDomainId = onChangesObj['selectedDomainId'].currentValue;
      this.getDomainData(this.selectedDomainId);
    }
    if (onChangesObj['showAggregated'] && isDefined(onChangesObj['showAggregated'].currentValue)) {
      this.showAggregated = onChangesObj['showAggregated'].currentValue;
      if (isObject(this.selectedDomain)) {
        this.getDomainData(this.selectedDomain.id);
      }
    }
  }

  private getMetrics(domain: Domain) {
    let metrics = domain.metrics;
    if (this.showAggregated) {
      metrics = domain.aggregatedMetrics;
    }
    return metrics;
  }

  occupationRate() {
    if (this.selectedDomain) {
      return computeOccupationRate(this.getMetrics(this.selectedDomain));
    }
    return 0;
  }

  handledRate() {
    if (this.selectedDomain) {
      return computeHandledRate(this.getMetrics(this.selectedDomain));
    }
    return 0;
  }

  avgProcessTime() {
    if (this.selectedDomain) {
      return timeParts(computeAvgProcessTime(this.getMetrics(this.selectedDomain)));
    }
    return [0, 0, 0];
  }

  private generateChartData(data, mapping): any {
    let result = {};
    let metric;
    for (metric in data) {
      if (mapping.hasOwnProperty(metric)) {
        result[mapping[metric]] = data[metric];
      }
    }
    return result;
  }

  private getDomainData(selectedDomainId) {
    if (isString(selectedDomainId)) {
      this.selectedDomain = this.hypervision.getDomainMetrics(selectedDomainId).getOrNull();
      if (isObject(this.selectedDomain)) {
        let metrics = this.getMetrics(this.selectedDomain);
        this.occupationMetrics = this.generateChartData(metrics, this.occupationMetricsMapping);
        this.contactMetrics = this.generateChartData(metrics, this.contactMetricsMapping);
      }
    }
  }
}

export class DomainDashboard implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    selectedDomainId: '<',
    showAggregated: '<',
  };
  controller = ['hypervision', DomainDashboardViewCtrl];
}

export default 'domainDashboard';
